import { useTheme } from "@material-ui/core/styles";
import { DEFAULT_CLIENT_TEXT_COLOR } from "../theme/tokens";

// Fachada unica de consumo das cores da implementacao. Le os tokens ja
// derivados do tema (ver theme/tokens.js). Novos tokens semanticos so
// precisam ser expostos aqui para ficarem disponiveis em toda a app.
const useThemeColors = () => {
  const theme = useTheme();
  const custom = theme?.palette?.custom || {};

  return {
    // Superficies
    clientColor: custom.clientColor,
    clientColorLight: custom.clientColorLight,
    clientColorDark: custom.clientColorDark,
    clientColorTransparent: custom.clientColorTransparent,
    // Conteudo sobre superficies (on-color)
    clientTextColor: custom.clientTextColor || DEFAULT_CLIENT_TEXT_COLOR,
    clientTextColorOnDark:
      custom.clientTextColorOnDark || DEFAULT_CLIENT_TEXT_COLOR,
  };
};

export default useThemeColors;
